// frontend/src/components/DWILogo.jsx
// Official DWI FINTECH brand mark — SVG-based, no image files required.
// Variants: 'horizontal' (sidebar), 'vertical' (login), 'icon' (favicon/avatar)

export function DWILogoIcon({ size = 36, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="dwi-icon-grad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#1B61AC" />
          <stop offset="100%" stopColor="#00A8DB" />
        </linearGradient>
      </defs>
      {/* Rounded square base */}
      <rect width="40" height="40" rx="11" fill="url(#dwi-icon-grad)" />
      {/* Network nodes representing Digital Finance Ecosystem */}
      {/* Central node */}
      <circle cx="20" cy="20" r="3.5" fill="white" />
      {/* Top-left node */}
      <circle cx="11" cy="13" r="2.5" fill="white" fillOpacity="0.85" />
      {/* Top-right node */}
      <circle cx="29" cy="13" r="2.5" fill="white" fillOpacity="0.85" />
      {/* Bottom-left node */}
      <circle cx="11" cy="27" r="2" fill="white" fillOpacity="0.65" />
      {/* Bottom-right node */}
      <circle cx="29" cy="27" r="2" fill="white" fillOpacity="0.65" />
      {/* Connections */}
      <line x1="11" y1="13" x2="20" y2="20" stroke="white" strokeWidth="1.2" strokeOpacity="0.6" />
      <line x1="29" y1="13" x2="20" y2="20" stroke="white" strokeWidth="1.2" strokeOpacity="0.6" />
      <line x1="11" y1="27" x2="20" y2="20" stroke="white" strokeWidth="1" strokeOpacity="0.4" />
      <line x1="29" y1="27" x2="20" y2="20" stroke="white" strokeWidth="1" strokeOpacity="0.4" />
      <line x1="11" y1="13" x2="29" y2="13" stroke="white" strokeWidth="0.8" strokeOpacity="0.3" />
    </svg>
  );
}

export function DWILogoHorizontal({ collapsed = false, portal = '' }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <DWILogoIcon size={32} />
      {!collapsed && (
        <div>
          <div style={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 800,
            fontSize: 14,
            lineHeight: 1.1,
            letterSpacing: '-0.02em',
          }}>
            <span style={{ color: '#F0F6FF' }}>DWI </span>
            <span style={{ color: '#00A8DB' }}>FINTECH</span>
          </div>
          <div style={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            fontSize: 9,
            letterSpacing: '0.10em',
            textTransform: 'uppercase',
            color: '#4E677E',
            marginTop: 1,
          }}>
            {portal || 'Digital Finance Ecosystem'}
          </div>
        </div>
      )}
    </div>
  );
}

export function DWILogoVertical({ size = 56 }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
      <DWILogoIcon size={size} />
      <div style={{ textAlign: 'center' }}>
        <div style={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 900,
          fontSize: 22,
          letterSpacing: '-0.03em',
          lineHeight: 1,
        }}>
          <span style={{ color: '#F0F6FF' }}>DWI </span>
          <span style={{ color: '#00A8DB' }}>FINTECH</span>
        </div>
        <div style={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 500,
          fontSize: 10,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          color: '#4E677E',
          marginTop: 6,
        }}>
          Digital Finance Ecosystem
        </div>
      </div>
    </div>
  );
}
